module.exports = __webpack_public_path__ + "img/kefu003.49007719.jpg";